import { useTheme } from "@/hooks/useTheme";
import { createStackNavigator } from "@react-navigation/stack";
import { DarkTheme, DefaultTheme, NavigationContainer, NavigationIndependentTree } from "@react-navigation/native";
import { PropsWithChildren } from "react";

const Stack = createStackNavigator();

interface StackNavigatorProps extends PropsWithChildren {
  initialRouteName?: string;
  onScreenChange?: (screenName: string) => void;
}

export default function StackNavigator({ children, initialRouteName, onScreenChange }: StackNavigatorProps) {
  const { colors, theme } = useTheme();
  return (
    <NavigationIndependentTree>
      <NavigationContainer
        documentTitle={{ enabled: false }}
        theme={{
          dark: theme.name === "dark",
          fonts: theme.name === "dark" ? DarkTheme.fonts : DefaultTheme.fonts,
          colors: {
            background: theme.card,
            border: theme.border,
            card: theme.card,
            primary: theme.primary,
            text: theme.text,
            notification: theme.name === "dark" ? DarkTheme.colors.notification : DefaultTheme.colors.notification,
          },
        }}
      >
        <Stack.Navigator
          initialRouteName={initialRouteName}
          screenListeners={({ route }) => ({
            focus: () => onScreenChange?.(route.name.toLowerCase()),
          })}
          screenOptions={{
            headerShown: true,
            headerTintColor: colors.text,
            headerShadowVisible: false,
            headerStyle: {
              backgroundColor: colors.backgroundSecondary,
            },
            headerTitleStyle: {
              color: colors.text,
            },
            cardStyle: {
              backgroundColor: colors.backgroundSecondary,
            },
          }}
        >
          {children}
        </Stack.Navigator>
      </NavigationContainer>
    </NavigationIndependentTree>
  );
}

export { Stack };
